import { createContext } from "react";
const PartytownContext = /*#__PURE__*/createContext({});
export { PartytownContext };